import React from "react";
import { Letest } from "./Props";

const Latest = () => {
    return (
        <>
            <div className="Latest-block" id="Latest">
                <div className="container">
                    <div className="Latest-inner">
                        <div className="title1" data-aos="fade-right">
                            <div className="title-inner">
                                <span>Read</span>
                                <h2>Latest News</h2>
                            </div>
                        </div>
                        <div className="row-main" data-aos="fade-left">
                            <Letest text="August 16, 2021" comment="1 Comment" Shots="Black & White Shots" text2="Black and white shots facilisis libero libero, eget cursus ex maximus non kuisque volutpat venenatis lacus sed the hendrerit nisi. Vivense facilisis..." more="Read More" />
                            <Letest text="August 16, 2021" comment="1 Comment" Shots="Product Shots" text2="Black and white shots facilisis libero libero, eget cursus ex maximus non kuisque volutpat venenatis lacus sed the hendrerit nisi. Vivense facilisis..." more="Read More" />
                            <Letest text="August 16, 2021" comment="1 Comment" Shots="Lovely Wedding" text2="Love wedding facilisis libero libero, eget cursus ex maximus non kuisque volutpat venenatis lacus sed the hendrerit nisi. Vivense facilisis libero libero..." more="Read More" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Latest;